export class TextableError extends Error {

  constructor(message: string) {
    super(message);
  }
}